import { AcquireBookPresenter } from "./presenter";

export const AcquireBookContainer: React.FC = () => {
  return <AcquireBookPresenter />;
};
